import { Stack, Text } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import styled from '@emotion/styled';
import { ConfirmOrderContent } from '../ConfirmOrderContent';
import { TextWithLineBreak } from '../../ConfirmOrderContainer.styles';
import cancelDowngrades from '../../../../../resources/images/cancel-downgrades.svg';
import { CostChangesSummary } from '../../../edit-order/cost-changes/cost-changes-summary/CostChangesSummary';
import type { OrganizationListItem } from '~/subscription-management/features/service-resource-list/hooks/useServiceResourceList';
import type {
  BillingPeriod,
  ProductAllowance,
} from '~/subscription-management/api/common/model/subscription';
import type { Currency } from '~/subscription-management/api/common/model/customer';

interface Props {
  onSubmit(): void;
  onCancel(): void;
  allResources?: OrganizationListItem[];
  updatedProducts: ProductAllowance[];
  billingPeriod: BillingPeriod;
  currency: Currency;
}

const S = {
  Stack: styled(Stack)`
    align-items: flex-start;
  `,
};

export function Reactivation({
  onSubmit,
  onCancel,
  allResources,
  updatedProducts,
  billingPeriod,
  currency,
}: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:reactivate');

  return (
    <ConfirmOrderContent
      contentLabel={t('title')}
      onCancel={() => onCancel()}
      onSubmit={() => onSubmit()}
      footerActions={[
        {
          kind: 'ghost',
          children: t('action.cancel'),
          onClickType: 'cancel',
        },
        {
          kind: 'primary',
          children: t('action.submit'),
          onClickType: 'submit',
        },
      ]}
    >
      <S.Stack spacing="x4">
        <img src={cancelDowngrades} alt={t('title')} />

        <Stack direction="column" spacing="x4">
          <Text textType="header4" as="h1">
            {t('title')}
          </Text>

          <TextWithLineBreak>{t('description')}</TextWithLineBreak>

          <CostChangesSummary
            defaultExpanded
            allResources={allResources}
            updatedProducts={updatedProducts}
            billingPeriod={billingPeriod}
            currency={currency}
            showCosts={false}
            title={t('changes-title')}
          />
        </Stack>
      </S.Stack>
    </ConfirmOrderContent>
  );
}
